// import Vue from "vue";
import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/HomePage.vue";

// Vue.use(router);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "Michel Robert | Digital Product Designer",
      metaTags: [
        {
          name: "description",
          content:
            "Portfolio website for Michel Robert | Digital Product Designer",
        },
      ],
    },
  },
  {
    path: "/kimo",
    name: "KIMO",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/KimoProject.vue"),
    meta: {
      title: "Michel Robert | Digital Product Designer",
      metaTags: [
        {
          name: "description",
          content:
            "Portfolio website for Michel Robert | Digital Product Designer",
        },
      ],
    },
  },
  {
    path: "/duikhuis",
    name: "Duikhuis",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/DuikhuisProject.vue"),
    meta: {
      title: "Michel Robert | Digital Product Designer",
      metaTags: [
        {
          name: "description",
          content:
            "Portfolio website for Michel Robert | Digital Product Designer",
        },
      ],
    },
  },
  {
    path: "/abn",
    name: "ABN AMRO",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/AbnProject.vue"),
    meta: {
      title: "Michel Robert | Digital Product Designer",
      metaTags: [
        {
          name: "description",
          content:
            "Portfolio website for Michel Robert | Digital Product Designer",
        },
      ],
    },
  },
  {
    path: "/hollandcasino",
    name: "Holland Casino",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HollandCasinoProject.vue"),
    meta: {
      title: "Michel Robert | Digital Product Designer",
      metaTags: [
        {
          name: "description",
          content:
            "Portfolio website for Michel Robert | Digital Product Designer",
        },
      ],
    },
  },
  {
    path: "/appietoday",
    name: "Appie Today",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AppieTodayProject.vue"),
    meta: {
      title: "Michel Robert | Digital Product Designer",
      metaTags: [
        {
          name: "description",
          content:
            "Portfolio website for Michel Robert | Digital Product Designer",
        },
      ],
    },
  },
  {
    path: "/duikschool",
    name: "Duikschool.nl",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/DuikschoolProject.vue"),
    meta: {
      title: "Michel Robert | Digital Product Designer",
      metaTags: [
        {
          name: "description",
          content:
            "Portfolio website for Michel Robert | Digital Product Designer",
        },
      ],
    },
  },
  {
    path: "/sensorfact",
    name: "Sensorfact",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SensorfactProject.vue"),
    meta: {
      title: "Michel Robert | Digital Product Designer",
      metaTags: [
        {
          name: "description",
          content:
            "Portfolio website for Michel Robert | Digital Product Designer",
        },
      ],
    },
  },
  { path: "/:catchAll(.*)", redirect: { name: 'Home' } }
];

const router = createRouter({
  mode: "history",
  base: process.env.BASE_URL,
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
   return new Promise((resolve) => {
      resolve({ left: 0, top: 0 })
    })
  },
});

router.beforeEach((to, from, next) => {
  /* It will change the title when the router is changed*/
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
